import React from 'react';
import '../../App.css';
import Form from 'react-bootstrap/Form';
import { ref, set } from "firebase/database";
import { database } from '../../firebase-config.js';
import { useState } from "react";

export default function CadastroCachorro() {

    const [tutor, setTutor] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [cep, setCep] = useState("");
    const [nomeDog, setNomeDog] = useState("");
    const [racaDog, setRacaDog] = useState("");
    const [idadeDog, setIdadeDog] = useState("");
    const [pesoDog, setPesoDog] = useState("");
    const [testLei, setTestLei] = useState("");
    const [transDog, setTransDog] = useState("");
    const [vacDog, setVacDog] = useState("");
    const [vermeDog, setVermeDog] = useState("");

    async function writeUserData(tutor, email, telefone, cep, nomeDog, racaDog, idadeDog, pesoDog, testLei, transDog, vacDog, vermeDog) {
        await (ref(database, 'Cachorro/' + cep + '/' + tutor + '/' + nomeDog), {
            tutor: tutor,
            email: email,
            telefone: telefone,
            cep: cep,
            nomeDog: nomeDog,
            racaDog: racaDog,
            idadeDog: idadeDog,
            pesoDog: pesoDog,
            testLei: testLei,
            transDog: transDog,
            vacDog: vacDog,
            vermeDog: vermeDog
        });

        window.location.href = '/cadastro-sucesso';
    }

    const handleSubmit = event => {
        console.log('handleSubmit ran');
        event.preventDefault(); // prevent page refresh

        if (tutor === '') {
            console.log('tutor is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (email === '') {
            console.log('email is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (telefone === '') {
            console.log('telefone is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (cep === '' || cep.length != 8) {
            console.log('cep is invalid');
            //TODO: Deixar vermelho e dizer q tem q preencher e checar CEP direito
            return;
        }
        if (nomeDog === '') {
            console.log('nomeDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (racaDog === '') {
            console.log('racaDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (idadeDog === '') {
            console.log('idadeDog is invalid');
            //TODO: Deixar vermelho e dizer q tem q preencher
            //TODO: 1 a 8 anos
            return;
        }
        if (pesoDog === '') {
            console.log('pesoDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            //TODO: >25kg
            return;
        }
        if (testLei === '') {
            console.log('testLei is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (transDog === '') {
            console.log('transDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        /*if (vacDog === '') {
            console.log('vacDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }
        if (vermeDog === '') {
            console.log('vermeDog is empty');
            //TODO: Deixar vermelho e dizer q tem q preencher
            return;
        }*/

        //TODO: Pet ja cadastrado se ja for encontrado no sistema


        // access input values here
        console.log('tutor ', tutor);
        console.log('email', email);
        console.log('telefone ', telefone);
        console.log('cep', cep);
        console.log('nomeDog ', nomeDog);
        console.log('racaDog', racaDog);
        console.log('idadeDog ', idadeDog);
        console.log('pesoDog', pesoDog);
        console.log('testLei ', testLei);
        console.log('transDog', transDog);
        console.log('vacDog ', vacDog);
        console.log('vermeDog', vermeDog);

        
        writeUserData(tutor, email, telefone, cep, nomeDog, racaDog, idadeDog, pesoDog, testLei, transDog, vacDog, vermeDog);
    };

    return <>
        <meta charset="UTF-16" />
        <body className="cadastro-cachorro">
            <Form onSubmit={handleSubmit}>
                <div className='titulo'> Tutor: </div>

                <Form.Group className='formNomeTutor' controlId="formGroupNomeTutor">
                    <Form.Label>Nome Completo: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setTutor(event.target.value)} />
                </Form.Group>

                <Form.Group className='formEmail' controlId="formGroupEmail">
                    <Form.Label>Email: </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="email@dominio.com"
                        onChange={event => setEmail(event.target.value)} />
                </Form.Group>

                <Form.Group className='formTelefone' controlId="formGroupTelefone">
                    <Form.Label>Telefone: </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="(XX)XXXXX-XXXX"
                        onChange={event => setTelefone(event.target.value)} />
                </Form.Group>

                <Form.Group className='formEndereco' controlId="formGroupEndereco">
                    <Form.Label>CEP: </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="XXXXX-XXX"
                        onChange={event => setCep(event.target.value)} />
                </Form.Group>

                <div className='titulo'> Pet: </div>

                <Form.Group className='formNomePet' controlId="formGroupNomePet">
                    <Form.Label>Nome do Pet: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setNomeDog(event.target.value)} />
                </Form.Group>

                <Form.Group className='formRaca' controlId="formGroupRaca">
                    <Form.Label> Ra&ccedil;a: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setRacaDog(event.target.value)} />
                </Form.Group>

                <Form.Group className='formIdade' controlId="formGroupIdade">
                    <Form.Label>Idade: </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setIdadeDog(event.target.value)} />
                </Form.Group>

                <Form.Group className='formPeso' controlId="formGroupPeso">
                    <Form.Label>Peso (kg): </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={event => setPesoDog(event.target.value)} />
                </Form.Group>

                <Form.Group className="formLeish" controlId="formGroupLeish">
                    <Form.Label> Testado para Leishmaniose? </Form.Label>
                    <Form.Select aria-label="�" onChange={event => setTestLei(event.target.value)}>
                        <option>Selecione uma op&ccedil;&atilde;o</option>
                        <option value="Sim">Sim</option>
                        <option value="Nao">N&atilde;o</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="formTransfusao" controlId="formGroupTransfusao">
                    <Form.Label> Ja recebeu transfus&atilde;o de Sangue? </Form.Label>
                    <Form.Select aria-label="�" onChange={event => setTransDog(event.target.value)} >
                        <option>Selecione uma op&ccedil;&atilde;o</option>
                        <option value="Sim">Sim</option>
                        <option value="Nao">N&atilde;o</option>
                    </Form.Select>
                </Form.Group>

                <div className='titulo'> Anexos: </div>
                <Form.Group className="formVacina" controlId="formGroupVacina" >
                    <Form.Label>Cart&atilde;o de Vacina&ccedil;&atilde;o</Form.Label>
                    <Form.Control type="file" />
                </Form.Group>

                <Form.Group className="formVermifugo" controlId="formGroupVermifugo">
                    <Form.Label>Vermifugo em dia</Form.Label>
                    <Form.Control type="file" />
                </Form.Group>

                <div className="center">
                    <button className='btn--enviar' type="submit" >Enviar</button>
                </div>
            </Form>

            
        </body>
    </>;
}
